/**
 * SectionHeader 스타일
 * @description 시안 `3041:2420`. 제목은 왼쪽, "See all" 은 오른쪽 끝에 붙는다. 제목 옆
 *   자리(`trailing`)는 제목과 한 덩어리로 움직인다.
 *
 *   누르는 자리를 글자보다 넓힌다. 시안의 "See all" 은 글자 그대로지만, 12px 글자 한 줄은
 *   손끝으로 맞히기 어렵다 — 보이는 것은 그대로 두고 여백만 키운다.
 */
export const sectionHeaderStyles = {
  root: "flex w-full items-center justify-between gap-[var(--fw-space-gap-md)]",
  /** 제목 + 곁딸린 것. 길면 줄어드는 쪽이라 `flex-1` 을 준다 */
  lead: "flex min-w-0 flex-1 items-center gap-[var(--fw-space-gap-md)]",
  title:
    "fw-h3 min-w-0 truncate text-[var(--fw-color-content-neutral-secondary)]",
  seeAll:
    "fw-caption shrink-0 cursor-pointer py-[var(--fw-space-inset-xs)] pl-[var(--fw-space-inset-sm)] text-[var(--fw-color-content-neutral-tertiary)] hover:text-[var(--fw-color-content-neutral-secondary)]",
};
